import { render, staticRenderFns } from "./songRequest.vue?vue&type=template&id=59b796d0&scoped=true"
import script from "./songRequest.vue?vue&type=script&lang=js"
export * from "./songRequest.vue?vue&type=script&lang=js"
import style0 from "./songRequest.vue?vue&type=style&index=0&id=59b796d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b796d0",
  null
  
)

export default component.exports